import React from 'react';
import { useIntl } from 'react-intl';

/**
 * Replacement for the removed `FormattedHTMLMessage` from react-intl v2.
 *
 * NOTE: This renders HTML from translation strings via `dangerouslySetInnerHTML`.
 * Only use with trusted translation content.
 */
export default function FormattedHtmlMessage({
  id,
  defaultMessage,
  tagName = 'span'
}) {
  const intl = useIntl();
  const Tag = tagName;

  // If `id` is provided, try to fetch the translated message
  // Otherwise, use `defaultMessage` directly
  const message = id ? intl.messages[id] || defaultMessage : defaultMessage;

  return <Tag dangerouslySetInnerHTML={{ __html: message }} />;
}
